import { Modal, Button } from "react-bootstrap";

function TestCaseModal({ show, onClose, testCase }) {
  if (!testCase) return null;

  const getRowStyle = (index) => ({
    "--bs-table-bg": index % 2 === 0 ? "rgba(25, 135, 84, 0.06)" : "#ffffff"
  });

  const renderValue = (value) => value || <span className="text-muted">-</span>;

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Test Case {testCase.number}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <table className="table">
          <tbody>
            <tr style={getRowStyle(0)}>
              <th style={{ width: "180px" }}>Name</th>
              <td>{renderValue(testCase.name)}</td>
            </tr>
            <tr style={getRowStyle(1)}>
              <th>Type</th>
              <td>{renderValue(testCase.type)}</td>
            </tr>
            <tr style={getRowStyle(2)}>
              <th>Description</th>
              <td style={{ whiteSpace: "pre-wrap" }}>{renderValue(testCase.description)}</td>
            </tr>
            <tr style={getRowStyle(3)}>
              <th>Expected result</th>
              <td style={{ whiteSpace: "pre-wrap" }}>{renderValue(testCase.expectedResult)}</td>
            </tr>
            <tr style={getRowStyle(4)}>
              <th>User</th>
              <td>{renderValue(testCase.User?.name)}</td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TestCaseModal;
